import React from 'react'
import { Route, Routes } from 'react-router-dom'
import FormInfo from '../lte-teacher-volunteer/FormInfo'
import EndPageModal from '../thankyou-modal/EndPageModal'

const AllRoutes = () => {
  return (
    <Routes>
        <Route path ="/" element ={<FormInfo/>}/>
        <Route path="/end"  element ={<EndPageModal />}/>
    </Routes>
  )
}

export default AllRoutes